import styled from 'styled-components'
import { up } from 'styled-breakpoints'

const Container = styled.div`
  > * {
    margin-top: 0 !important;
    margin-bottom: 8rem !important;

    ${up('md')} {
      margin-bottom: 13.6rem !important;
    }
  }
`

const Layout: React.FC = ({ children }) => (
  <Container className="mb-80 mb-md-200">{children}</Container>
)

export default Layout
